import React, {useEffect, useState} from "react";
import BankFormWizard from "../../components/form/BankFormWizard";
import {useGetBanksQuery, useUpdateBankMutation} from "../../../../../redux/apiSlice";
import {useSubheader} from "../../../../../_metronic/layout";
import Skeleton from "react-loading-skeleton";
import cogoToast from "cogo-toast";

export const EditBank = ({match, history, location}) => {
    const [tab, setTab] = useState(1);

    const {bankDetails} = useGetBanksQuery(match?.params?.bankRef, {
        selectFromResult: ({data}) => ({
            bankDetails: data?.data?.find((bank) => bank.ref === match.params.bankRef),
        }),
    })

    const subheader = useSubheader();

    useEffect(() => {
        subheader.setTitle(bankDetails?.bankName || <Skeleton count="1" width={"100px"}/>)
    }, [bankDetails])

    const [
        updateBank, // This is the mutation trigger
        {
            isLoading: isUpdating,
            isSuccess: updatedSuccessfully,
        }, // This is the destructured mutation result
    ] = useUpdateBankMutation()

    /* Clear fields on success */
    useEffect(() => {
        if (updatedSuccessfully) {
            cogoToast.success("Created 'Bank Update' Action Successfully")
            setTab(1)
            history.push("/overview/banks/view")
        }
    }, [history, updatedSuccessfully]);

    /* Submit exchange rate data */
    const submitData = async data => {
        updateBank({ref: match.params.bankRef, ...data, meta: bankDetails});
    }

    return (
        !bankDetails
            ? <div/>
            : <BankFormWizard
                key={location.key}
                data={bankDetails}
                tab={tab} // Reset Tab on success
                setTab={setTab}
                isLoading={isUpdating}
                submitData={submitData}
            />
    )
}